<!-- View header. -->
<script lang="ts">
  import type { Snippet } from "svelte";
  let { title, sub = "" }: { title: string; sub?: Snippet | string } = $props();
</script>

<div class="view-head"><h1>{title}</h1><span class="sub">{#if typeof sub === "string"}{sub}{:else}{@render sub()}{/if}</span></div>
